import React, { useState } from "react";
import { useAuth } from "../context/AuthProvider";
import { useTemplate } from "../context/TemplateProvider";
import AxiosAuth from "../utility/AxiosAuth";
import ConfigApi from "../utility/ConfigApi";
import { handleFormSubmit2 } from "../utility/formHelpers";

export default function LoginPage () {
  const [ isLoading,setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const { login,setUserSl } = useAuth();
  const [isNewCreate,setIsNewCreate]=useState(false)  
  const {setMessage,setLoading} = useTemplate();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();


  const handleLogin = () => {
    
    AxiosAuth.post(ConfigApi.LOGIN, {email,password})
    .then(({data}) => {
      
      if (data.error===0) {
        localStorage.setItem('userId', data.user_id);
        login()
        setUserSl(data.user_id)
        setMessage({type: 'success', text: data.message})
      }else{

        setMessage({type: 'error', text: data.message})
      }
      
    })
    .catch(errr => {
      console.log(errr);
      
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(123)    
    try {
      const data = await handleFormSubmit2(ConfigApi.REGISTER, event.currentTarget, setIsLoading, setError);
      setLoading();
      if (data?.error===0) {
        setIsNewCreate(false)
        setMessage({type: 'success', text: data?.message})
      }else{
        setMessage({type: 'error', text: data?.message})
      }
    } catch (error) {
    }
  };

  if (isNewCreate) {
    return (
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
              <svg className="mx-auto h-10 w-auto" width="134" height="40" viewBox="0 0 134 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M40 0H0V40H40V0ZM87 0H47V40H87V0ZM94 0H134V40H94V0ZM26.8086 21.9922V18.8086H17.6094V10.1953H26.2031L27.1992 13.8086H29.7969V6.99219H17.6094L9.99219 7.20703V9.39453L13.3906 10.1953V31.7969L9.99219 32.5977V35H30.207V27.793H27.6094L26.8086 31.7969H17.6094V21.9922H26.8086ZM74.3984 19.1992V22.4023H65.1992V31.7969L69.2031 32.5977V35H57.6016V32.5977L61 31.7969V10.1953L57.6016 9.39453V7.20703L65.1992 6.99219H77.4062V13.5938H74.8086L73.793 10.1953H65.1992V19.1992H74.3984ZM109.52 31.3281C109.142 31.1589 108.901 31.0482 108.797 30.9961L107.996 26.7969H104.793V33.8086C105.014 33.8867 105.522 34.056 106.316 34.3164C107.124 34.5638 108.133 34.8047 109.344 35.0391C110.555 35.2734 111.785 35.3906 113.035 35.3906C114.962 35.3906 116.714 35.0716 118.289 34.4336C119.878 33.7956 121.141 32.819 122.078 31.5039C123.016 30.1758 123.484 28.5547 123.484 26.6406C123.484 25.1172 123.094 23.8607 122.312 22.8711C121.544 21.8685 120.607 21.0938 119.5 20.5469C118.393 20 116.974 19.4206 115.242 18.8086C113.797 18.3008 112.671 17.8581 111.863 17.4805C111.069 17.1029 110.405 16.6276 109.871 16.0547C109.337 15.4688 109.07 14.7461 109.07 13.8867C109.07 12.819 109.533 11.9076 110.457 11.1523C111.382 10.3841 112.697 10 114.402 10C115.04 10 115.678 10.0521 116.316 10.1562C116.954 10.2604 117.475 10.3776 117.879 10.5078C118.283 10.625 118.536 10.6966 118.641 10.7227L120.008 15H122.605L122.801 8.20312C122.566 8.125 122.007 7.96224 121.121 7.71484C120.236 7.45443 119.168 7.20703 117.918 6.97266C116.668 6.72526 115.483 6.60156 114.363 6.60156C111.642 6.60156 109.376 7.26562 107.566 8.59375C105.77 9.92188 104.871 11.9076 104.871 14.5508C104.871 16.2044 105.262 17.5586 106.043 18.6133C106.837 19.668 107.788 20.4753 108.895 21.0352C110.014 21.5951 111.479 22.194 113.289 22.832C114.669 23.3398 115.75 23.776 116.531 24.1406C117.326 24.5052 117.99 24.9805 118.523 25.5664C119.057 26.1393 119.324 26.8555 119.324 27.7148C119.324 29.056 118.699 30.1042 117.449 30.8594C116.212 31.6146 114.793 31.9922 113.191 31.9922C112.423 31.9922 111.714 31.9206 111.062 31.7773C110.411 31.6341 109.897 31.4844 109.52 31.3281Z" fill="#86D2F4"/>
                  </svg>
                
                <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                  Create a new account
                </h2>
            </div>
    
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
                    Company Name
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="company"
                      placeholder="Type Company Name"
                      className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
                    Owner Name
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="owner"
                      placeholder="Type Company Owner Name"
                      className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                    Email address
                  </label>
                  <div className="mt-2">
                    <input
                      type="email"
                      name="email"
                      placeholder="Type Email Address"
                      className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
                    Contact Number
                  </label>
                  <div className="mt-2">
                    <input
                      type="text"
                      name="contact"
                      placeholder="Type Contact Number"
                      className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
    
                <div>
                  <div className="flex items-center justify-between">
                    <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                      Password
                    </label>
                  </div>
                  <div className="mt-2">
                    <input
                      type="password"
                      name="password"
                      placeholder="********"
                      className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
    
                <div>
                  <button type="submit"
                    className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Create New
                  </button>
                </div>
                  <div className="text-sm">
                      <button onClick={()=>setIsNewCreate(false)} className="font-semibold text-indigo-600 hover:text-indigo-500">
                      Back to Login
                      </button>
                  </div>
              </form>
            </div>
          </div>
      );
  }
  
  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <svg className="mx-auto h-10 w-auto" width="134" height="40" viewBox="0 0 134 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M40 0H0V40H40V0ZM87 0H47V40H87V0ZM94 0H134V40H94V0ZM26.8086 21.9922V18.8086H17.6094V10.1953H26.2031L27.1992 13.8086H29.7969V6.99219H17.6094L9.99219 7.20703V9.39453L13.3906 10.1953V31.7969L9.99219 32.5977V35H30.207V27.793H27.6094L26.8086 31.7969H17.6094V21.9922H26.8086ZM74.3984 19.1992V22.4023H65.1992V31.7969L69.2031 32.5977V35H57.6016V32.5977L61 31.7969V10.1953L57.6016 9.39453V7.20703L65.1992 6.99219H77.4062V13.5938H74.8086L73.793 10.1953H65.1992V19.1992H74.3984ZM109.52 31.3281C109.142 31.1589 108.901 31.0482 108.797 30.9961L107.996 26.7969H104.793V33.8086C105.014 33.8867 105.522 34.056 106.316 34.3164C107.124 34.5638 108.133 34.8047 109.344 35.0391C110.555 35.2734 111.785 35.3906 113.035 35.3906C114.962 35.3906 116.714 35.0716 118.289 34.4336C119.878 33.7956 121.141 32.819 122.078 31.5039C123.016 30.1758 123.484 28.5547 123.484 26.6406C123.484 25.1172 123.094 23.8607 122.312 22.8711C121.544 21.8685 120.607 21.0938 119.5 20.5469C118.393 20 116.974 19.4206 115.242 18.8086C113.797 18.3008 112.671 17.8581 111.863 17.4805C111.069 17.1029 110.405 16.6276 109.871 16.0547C109.337 15.4688 109.07 14.7461 109.07 13.8867C109.07 12.819 109.533 11.9076 110.457 11.1523C111.382 10.3841 112.697 10 114.402 10C115.04 10 115.678 10.0521 116.316 10.1562C116.954 10.2604 117.475 10.3776 117.879 10.5078C118.283 10.625 118.536 10.6966 118.641 10.7227L120.008 15H122.605L122.801 8.20312C122.566 8.125 122.007 7.96224 121.121 7.71484C120.236 7.45443 119.168 7.20703 117.918 6.97266C116.668 6.72526 115.483 6.60156 114.363 6.60156C111.642 6.60156 109.376 7.26562 107.566 8.59375C105.77 9.92188 104.871 11.9076 104.871 14.5508C104.871 16.2044 105.262 17.5586 106.043 18.6133C106.837 19.668 107.788 20.4753 108.895 21.0352C110.014 21.5951 111.479 22.194 113.289 22.832C114.669 23.3398 115.75 23.776 116.531 24.1406C117.326 24.5052 117.99 24.9805 118.523 25.5664C119.057 26.1393 119.324 26.8555 119.324 27.7148C119.324 29.056 118.699 30.1042 117.449 30.8594C116.212 31.6146 114.793 31.9922 113.191 31.9922C112.423 31.9922 111.714 31.9206 111.062 31.7773C110.411 31.6341 109.897 31.4844 109.52 31.3281Z" fill="#86D2F4"/>
            </svg>
          
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Sign in to your account
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="space-y-6">
            <div>
              <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e)=>setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="Type Email Address"
                  className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                  Password
                </label>
                <div className="text-sm">
                  <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">
                    Forgot password?
                  </a>
                </div>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  value={password}
                  onChange={(e)=>setPassword(e.target.value)}
                  autoComplete="current-password"
                  placeholder="********"
                  className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <button
                onClick={handleLogin}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
            <div className="text-sm">
                <button onClick={()=>setIsNewCreate(true)} className="font-semibold text-indigo-600 hover:text-indigo-500">
                Create a New Account
                </button>
            </div>
          </div>
        </div>
      </div>
  );
};

